export default __webpack_public_path__ + "static/media/Thumbnail-Newsletter-1.2696c53a.png";